export default "__VITE_ASSET__396958e3__"